/**
 * Name: Video
 */

import Component from "@lunaweb/vega-reactor-js/src/patterns/Component";

export default class Video extends Component {

  static settings = {};

  #control;
  #player;

  #handleControlClick

  constructor (element, options = {}) {
    super(element, {
      ...Video.settings,
      ...options
    });

    this.#control = this.element.querySelector('.js-video-control');
    this.#player = this.element.querySelector('.js-video-player');

    this.#handleControlClick = this._handleControlClick.bind(this);
  }

  _handleControlClick () {
    this.#player.focus();
    this.element.classList.add('is-displayed');
  }

  mount () {
    this.#control.addEventListener('click', this.#handleControlClick);
    super.mount();
  }

  unmount () {
    this.#control.removeEventListener('click', this.#handleControlClick);
    super.unmount();
  }
}
